<template>
  <el-form :model="form" ref="form">
    <el-form-item prop="nomeFantasia">
      <h3>Assinatura</h3>
      <el-radio-group v-model="form.tipo">
        <el-radio-button label="Em conjunto"></el-radio-button>
        <el-radio-button label="Isolada"></el-radio-button>
      </el-radio-group>

      <br>

      <em v-if="form.tipo === 'Em conjunto'"><strong>Importante:</strong> A assinatura perante Instituições Públicas e Bancárias só terá validade se tiver a assinatura de ambos os sócios</em>
    </el-form-item>

    <h3>Será exercida pelos sócios:</h3>

    <div v-for="(socio, index) in form.socios">
      <el-form-item label="Nome Completo" :prop="'socios.' + index + '.nome'" :rules="{ required: true, message: 'O nome é obrigatório', trigger: 'blur'}">
        <el-button type="danger" size="mini" @click="removerSocio(socio)" icon="delete" v-if="form.socios.length > 1">Deletar</el-button>
        <el-input v-model="socio.nome"></el-input>
      </el-form-item>
    </div>

    <el-form-item>
      <el-button type="success" @click="adicionarSocio">Adicionar Sócio</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: ['form'],

  methods: {
    removerSocio (item) {
      this.form.socios.splice(this.form.socios.indexOf(item), 1)
    },

    adicionarSocio () {
      this.form.socios.push({
        key: Date.now(),
        nome: ''
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// AdministracaoAssinatura.vue?20a20411